import { cn } from "@getgreenline/blaze-ui";
import { type MarketState } from "@/hooks/use-markets-catalog";
import { CardBadge } from "../../shared/card-badge";
import { SelectableCard } from "../../shared/selectable-card";

type MarketStateCardProps = {
  state: MarketState;
  selected: boolean;
  onSelect: () => void;
};

export function MarketStateCard({
  state,
  selected,
  onSelect,
}: MarketStateCardProps) {
  return (
    <SelectableCard
      interactive={state.available}
      selected={selected}
      dimmed={!state.available}
      onSelect={onSelect}
      contentClassName="tw:flex tw:items-center tw:gap-4"
    >
      <div
        className={cn(
          "tw:flex tw:h-10 tw:w-10 tw:items-center tw:justify-center tw:rounded-xl tw:text-[11px] tw:font-semibold",
          state.accent,
        )}
      >
        {state.code}
      </div>
      <div className="tw:min-w-0 tw:flex-1">
        <div className="tw:flex tw:items-center tw:justify-between tw:gap-4">
          <div>
            <h3 className="tw:text-sm tw:font-semibold tw:text-foreground">
              {state.name}
            </h3>
            <p className="tw:text-sm tw:text-muted-foreground">{state.meta}</p>
          </div>
          <CardBadge
            variant="secondary"
            className={cn(
              state.available
                ? "tw:bg-sky-100 tw:text-sky-800"
                : "tw:bg-muted tw:text-muted-foreground",
            )}
          >
            {state.status}
          </CardBadge>
        </div>
      </div>
    </SelectableCard>
  );
}
